/** Session helpers — talk to the BFF's /api/* (NOT the SOAP endpoint). */

export interface Session {
  user: string;
  csrfToken: string;
  /** Deling (share.mo2.dk) integration available for this account */
  shareEnabled?: boolean;
}

export async function getSession(): Promise<Session | null> {
  const res = await fetch('/api/me', { credentials: 'same-origin' });
  if (!res.ok) return null;
  const data = (await res.json()) as { user: string; csrfToken: string | null; shareEnabled?: boolean };
  if (!data.csrfToken) return null;
  return { user: data.user, csrfToken: data.csrfToken, shareEnabled: !!data.shareEnabled };
}

export async function login(username: string, password: string): Promise<Session> {
  const res = await fetch('/api/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ username, password }),
  });
  if (!res.ok) {
    throw new Error('Invalid username or password');
  }
  const s = (await res.json()) as Session;
  // /api/me knows the account's primary address → whether Deling is enabled
  const me = await getSession().catch(() => null);
  return { ...s, shareEnabled: !!me?.shareEnabled };
}

export async function logout(): Promise<void> {
  await fetch('/api/logout', { method: 'POST', credentials: 'same-origin' });
}
